import React, { useMemo, useState } from 'react';
import { Label, Pane, Selector, Text } from '@leverege/ui-elements';
import DefaultDialog from '../../components/DefaultDialog';
import Loading from '../../components/Loading';
import S from './SetConfigurationDialog.css';
import useDeviceAndStateConfigOptions from './logic/useDeviceAndStateConfigOptions';
import useUpdateDeviceAndStateConfigs from './logic/useUpdateDeviceAndStateConfigs';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function SetConfigurationDialog(props) {
  const {
    locationIds,
    sku,
    onClose,
    server
  } = props;
  const placeHolder = {
    id: 'placeHolder',
    selectorLabel: 'Select a config'
  };
  const [selectedDeviceConfiguration, setSelectedDeviceConfiguration] = useState(placeHolder.id);
  const [selectedStateConfiguration, setSelectedStateConfiguration] = useState(placeHolder.id);
  const {
    loading: loadingConfigurations,
    locations,
    currentKeystreamIds,
    deviceConfigurationOptions,
    stateConfigurationOptions
  } = useDeviceAndStateConfigOptions({
    sku,
    locationIds,
    placeHolder,
    server
  });
  const {
    loading: updatingConfigs,
    sendNewConfigurations
  } = useUpdateDeviceAndStateConfigs({
    placeHolder,
    sku,
    locations,
    selectedDeviceConfiguration,
    selectedStateConfiguration,
    deviceConfigurationOptions,
    stateConfigurationOptions,
    onClose,
    server
  });
  const locationInfo = useMemo(() => {
    if (locations.length === 1) {
      return locations[0]?.data?.name;
    }
    return `${locations.length} locations`;
  }, [locations]);
  const selectorRenderer = (value, selectorLabel) => {
    if (value.id === 'placeHolder') {
      return /*#__PURE__*/_jsx("em", {
        children: selectorLabel
      });
    }
    if (currentKeystreamIds.includes(value.keystreamId)) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("b", {
          children: "(currently in use)"
        }), "\xA0", selectorLabel]
      });
    }
    return selectorLabel;
  };
  const isConfigInvalid = (selectedConfiguration, configurationOptions) => {
    const isConfigPlaceHolderSelected = selectedConfiguration === placeHolder.id;
    const selectedOption = configurationOptions.find(opt => opt.id === selectedConfiguration);
    const isCurrentConfigSelected = currentKeystreamIds.includes(selectedOption?.keystreamId);
    return isCurrentConfigSelected || isConfigPlaceHolderSelected;
  };
  const isSubmitDisabled = () => {
    const isDeviceConfigInvalid = isConfigInvalid(selectedDeviceConfiguration, deviceConfigurationOptions);
    const isStateConfigInvalid = isConfigInvalid(selectedStateConfiguration, stateConfigurationOptions);
    return isDeviceConfigInvalid && isStateConfigInvalid;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(DefaultDialog, {
      ...props,
      submitDisabled: isSubmitDisabled(),
      onSubmit: sendNewConfigurations,
      title: "Set Configuration",
      titleIcon: "https://storage.googleapis.com/recovr-ui-assets/blueprintNavIcons/firmwareConfiguration-title.svg",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "bold",
        children: "Set Configuration"
      }), /*#__PURE__*/_jsxs(Text, {
        children: ["You have selected the device group for ", sku, " at ", locationInfo, ". You can update configuration for just device or state, or both at the same time."]
      }), /*#__PURE__*/_jsxs(Pane, {
        children: [/*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Device Configuration"
        }), /*#__PURE__*/_jsx(Selector, {
          className: S.selector,
          value: selectedDeviceConfiguration,
          showFilter: true,
          targetAttachment: "top right",
          valueKey: "id",
          nameKey: "selectorLabel",
          onChange: data => setSelectedDeviceConfiguration(data.value),
          renderer: selectorRenderer,
          values: deviceConfigurationOptions
        })]
      }), /*#__PURE__*/_jsxs(Pane, {
        children: [/*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "State Configuration"
        }), /*#__PURE__*/_jsx(Selector, {
          className: S.selector,
          value: selectedStateConfiguration,
          showFilter: true,
          targetAttachment: "top right",
          valueKey: "id",
          nameKey: "selectorLabel",
          onChange: data => setSelectedStateConfiguration(data.value),
          renderer: selectorRenderer,
          values: stateConfigurationOptions
        })]
      })]
    }), /*#__PURE__*/_jsx(Loading, {
      message: "Processing",
      loading: loadingConfigurations || updatingConfigs
    })]
  });
}
export default SetConfigurationDialog;